import React from 'react'

import { Box, Display } from '@gousto-internal/citrus-react'

import { CTAHomepageContainer } from 'routes/Home/CTA'
import { useGetCtaProps } from 'routes/Home/homeHooks'

import { CTAText } from '../../constants'
import { SectionContainer } from '../Containers.styled'

export interface CTAContainerProps {
  screenSize: 'smallAndMedium' | 'large'
}
export const CTAContainer = ({ screenSize }: CTAContainerProps) => {
  const { ctaUri } = useGetCtaProps()

  return screenSize === 'smallAndMedium' ? (
    <SectionContainer
      display={[Display.Block, null, Display.None]}
      width={['21.5rem', '17.5rem']}
      data-testid="SignupCTAContainer"
    >
      <CTAHomepageContainer ctaUri={ctaUri} sectionForTracking="priceComparisonTable">
        {CTAText.discountText}
      </CTAHomepageContainer>
    </SectionContainer>
  ) : (
    <Box
      display={[Display.None, null, Display.Block]}
      width="17.5rem"
      data-testid="SignupCTAContainer"
    >
      <CTAHomepageContainer ctaUri={ctaUri} sectionForTracking="priceComparisonTable">
        {CTAText.discountText}
      </CTAHomepageContainer>
    </Box>
  )
}
